import React from 'react';
import { useSelector } from 'react-redux';
import { useState, useEffect } from "react";
import useSnackbar from '../../../hooks/useSnackbar';
import { getTransactionCustom } from '../../../api/transaction-type';
import { slugMap } from '../../../config/slug-config';
import { useParams } from 'react-router-dom';
import { Box, Grid, CircularProgress, } from '@mui/material';
import { GridComp6 } from "../../../components/GridComponents";
import { CustomCheckBoxComp126 } from "../../../components/CheckboxComp"

export default function TransferCustom() {

  const snackbar = useSnackbar();
  const { data: user } = useSelector(state => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);

  const pageDetail = slugMap[params.slug];

  const [rowData, setRowData] = useState([]);

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {  
  //     setTableRefreshCount(prev => prev + 1);
  // }

  useEffect(() => {
    if (user.token) {
      getTransactionCustomData();
    }
  }, []);

  async function getTransactionCustomData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCustom(user.token, { id: params.docNo });
      setRowData(data.data.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      setLoading(false);
      return { error: true }
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading ? (
        <>
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "15px",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </>
      ) : (
        <Box className="viewDetilsBox">
          {/* {rowData.map((d, i) => ( */}
            <Grid container>
              <CustomCheckBoxComp126 title={"INTERCOMPANY CC TRANSACTION"} data={rowData.test_mode} />
              <GridComp6 title={"ENTITY BANK (EMPLOYEE)"} data={rowData.entity_bank_employee} />
              <GridComp6 title={"ENTITY BANK (VENDOR)"} data={rowData.entity_bank_vendor} />
            </Grid>
          {/* ))} */}
        </Box>
      )}
    </>
  )
}



